const emojiMore = [
  { text: 'grin', native: '😃' },
  { text: 'tongue', native: '😛' },
  { text: 'satisfied', native: '😔' },
  { text: 'triumph', native: '🤣' },
  { text: 'sunglasses', native: '😎' },
  { text: 'frowning', native: '🙁' },
  { text: 'grimacing', native: '😬' },
  { text: 'innocent', native: '😇' },
  { text: 'cop', native: '👮‍♀️' },
  { text: 'girl', native: '👧' },
  { text: 'man', native: '👨' },
  { text: 'construction_worker', native: '👷' },
  { text: 'smirk', native: '😏' },
  { text: 'neutral_face', native: '😐' },
  { text: 'anguished', native: '😧' },
  { text: 'sleeping', native: '😴' },
  { text: 'confounded', native: '😖' },
  { text: 'laughing', native: '😆' },
  { text: 'dizzy_face', native: '😵' },
  { text: 'smiling_imp', native: '😈' },
  { text: 'confused', native: '😕' },
  { text: 'expressionless', native: '😑' },
  { text: 'guardsman', native: '💂‍♂️' },
  { text: 'woman', native: '👩' },
  { text: 'older_man', native: '👴' },
  { text: 'baby', native: '👶' },
  { text: 'man_with_gua_pi_mao', native: '👲' },
  { text: 'hushed', native: '😯' },
  { text: 'imp', native: '👿' },
  { text: 'astonished', native: '😲' },
  { text: 'yum', native: '😋' },
  { text: 'mask', native: '😷' },
  { text: 'worried', native: '😟' },
  { text: 'open_mouth', native: '😮' },
  { text: 'no_mouth', native: '😶' },
  { text: 'man_with_turban', native: '👳' },
  { text: 'boy', native: '👦' },
  { text: 'older_woman', native: '👵' },
  { text: 'person_with_blond_hair', native: '👱' },
  { text: 'heart_eyes_cat', native: '😻' },
  { text: 'joy_cat', native: '😹' },
  { text: 'hear_no_evil', native: '🙉' },
  { text: 'fire', native: '🔥' },
  { text: 'anger', native: '💢' },
  { text: 'ear', native: '👂' },
  { text: 'eyes', native: '👀' },
  { text: 'sweat_drops', native: '💦' },
  { text: 'sparkles', native: '✨' },
  { text: 'speak_no_evil', native: '🙊' },
  { text: 'pouting_cat', native: '😾' },
  { text: 'kissing_cat', native: '😽' },
  { text: 'angel', native: '👼' },
  { text: 'princess', native: '👸' },
  { text: 'smirk_cat', native: '😼' },
  { text: 'japanese_ogre', native: '👹' },
  { text: 'skull', native: '💀' },
  { text: 'star2', native: '🌟' },
  { text: 'droplet', native: '💧' },
  { text: 'nose', native: '👃' },
  { text: 'tongue2', native: '👅' },
  { text: 'zzz', native: '💤' },
  { text: 'dizzy', native: '💫' },
  { text: 'alien', native: '👽' },
  { text: 'japanese_goblin', native: '👺' },
  { text: 'scream_cat', native: '🙀' },
  { text: 'smiley_cat', native: '😺' },
  { text: 'smile_cat', native: '😸' },
  { text: 'crying_cat_face', native: '😿' },
  { text: 'see_no_evil', native: '🙈' },
  { text: 'hankey', native: '💩' },
  { text: 'collision', native: '💥' },
  { text: 'dash', native: '💨' },
  { text: 'lips', native: '👄' },
  { text: 'thumbsup', native: '👍' },
  { text: '-1', native: '👎' },
  { text: 'v', native: '✌' },
  { text: 'point_down', native: '👇' },
  { text: 'point_up', native: '☝' },
  { text: 'dancer', native: '[企鹅跳跳]' },
  { text: 'couplekiss', native: '👩‍❤️‍💋‍👩' },
  { text: 'information_desk_person', native: '💁' },
  { text: 'raising_hand', native: '🙋' },
  { text: 'couple_with_heart', native: '💑' },
  { text: 'couple', native: '👫' },
  { text: 'clap', native: '👏' },
  { text: 'point_right', native: '👉' },
  { text: 'wave', native: '👋' },
  { text: 'ok_hand', native: '👌' },
  { text: 'raised_hand', native: '✋' },
  { text: 'point_left', native: '👈' },
  { text: 'muscle', native: '💪' },
  { text: 'family', native: '👪' },
  { text: 'dancers', native: '👯' },
  { text: 'massage', native: '💆' },
  { text: 'haircut', native: '💇' },
  { text: 'ok_woman', native: '🙆' },
  { text: 'two_men_holding_hands', native: '👬' },
  { text: 'walking', native: '🚶' },
  { text: 'raised_hands', native: '🙌' },
  { text: 'open_hands', native: '👐' },
  { text: 'punch', native: '👊' },
  { text: 'fist', native: '✊' },
  { text: 'point_up_2', native: '👆' },
  { text: 'pray', native: '🙏' },
  { text: 'running', native: '🏃' },
  { text: 'two_women_holding_hands', native: '👭' },
  { text: 'no_good', native: '🙅' },
  { text: 'nail_care', native: '💅' },
  { text: 'bride_with_veil', native: '👰' },
  { text: 'crown', native: '👑' },
  { text: 'high_heel', native: '👠' },
  { text: 'dress', native: '👗' },
  { text: 'briefcase', native: '💼' },
  { text: 'ribbon', native: '🎀' },
  { text: 'purple_heart', native: '💜' },
  { text: 'green_heart', native: '💚' },
  { text: 'closed_umbrella', native: '🌂' },
  { text: 'handbag', native: '👜' },
  { text: 'running_shirt_with_sash', native: '🎽' },
  { text: 'boot', native: '👢' },
  { text: 'womans_hat', native: '👒' },
  { text: 'person_with_pouting_face', native: '🙎' },
  { text: 'person_frowning', native: '🙍' },
  { text: 'shoe', native: '👟' },
  { text: 'shirt', native: '👕' },
  { text: 'jeans', native: '👖' },
  { text: 'pouch', native: '👝' },
  { text: 'lipstick', native: '💄' },
  { text: 'heart', native: '❤' },
  { text: 'broken_heart', native: '💔' },
  { text: 'yellow_heart', native: '💛' },
  { text: 'purse', native: '👛' },
  { text: 'kimono', native: '👘' },
  { text: 'necktie', native: '👔' },
  { text: 'mans_shoe', native: '👞' },
  { text: 'bow', native: '🙇' },
  { text: 'tophat', native: '🎩' },
  { text: 'sandal', native: '👡' },
  { text: 'womans_clothes', native: '👚' },
  { text: 'bikini', native: '👙' },
  { text: 'eyeglasses', native: '👓' },
  { text: 'blue_heart', native: '💙' },
  { text: 'heartpulse', native: '💗' },
  { text: 'heartbeat', native: '💓' },
  { text: 'two_hearts', native: '💕' },
  { text: 'sparkling_heart', native: '💖' },
  { text: 'revolving_hearts', native: '💞' },
  { text: 'cupid', native: '💘' },
  { text: 'love_letter', native: '💌' },
  { text: 'kiss', native: '💋' },
  { text: 'ring', native: '💍' },
  { text: 'gem', native: '💎' },
  { text: 'bust_in_silhouette', native: '👤' },
  { text: 'busts_in_silhouette', native: '👥' },
  { text: 'speech_balloon', native: '💬' },
  { text: 'feet', native: '👣' },
  { text: 'thought_balloon', native: '💭' },
  { text: 'bamboo', native: '🗯' },
  { text: 'gift_heart', native: '💝' },
  { text: 'dolls', native: '🎎' },
  { text: 'school_satchel', native: '🎒' },
  { text: 'mortar_board', native: '🎓' },
  { text: 'flags', native: '🎏' },
  { text: 'fireworks', native: '🎆' },
  { text: 'sparkler', native: '🎇' },
  { text: 'wind_chime', native: '🎐' },
  { text: 'rice_scene', native: '🎑' },
  { text: 'jack_o_lantern', native: '🎃' },
  { text: 'ghost', native: '👻' },
  { text: 'santa', native: '🎅' },
  { text: 'christmas_tree', native: '🎄' },
  { text: 'gift', native: '🎁' },
  { text: 'tanabata_tree', native: '🎋' },
  { text: 'tada', native: '🎉' },
  { text: 'confetti_ball', native: '🎊' },
  { text: 'balloon', native: '🎈' },
  { text: 'crossed_flags', native: '🎌' },
  { text: 'crystal_ball', native: '🔮' },
  { text: 'movie_camera', native: '🎥' },
  { text: 'camera', native: '📷' },
  { text: 'video_camera', native: '📹' },
  { text: 'vhs', native: '📼' },
  { text: 'cd', native: '🇭💿' },
  { text: 'dvd', native: '📀' },
  { text: 'minidisc', native: '💽' },
  { text: 'floppy_disk', native: '💾' },
  { text: 'computer', native: '💻' },
  { text: 'iphone', native: '📱' },
  { text: 'phone', native: '☎' },
  { text: 'telephone_receiver', native: '📞' },
  { text: 'pager', native: '📟' },
  { text: 'fax', native: '📠' },
  { text: 'satellite', native: '📡' },
  { text: 'tv', native: '📺' },
  { text: 'radio', native: '📻' },
  { text: 'speaker', native: '🔊' },
  { text: 'sound', native: '🔉' },
  { text: 'mute', native: '🔇' },
  { text: 'bell', native: '🔔' },
  { text: 'no_bell', native: '🔕' },
  { text: 'loudspeaker', native: '📢' },
  { text: 'mega', native: '📣' },
  { text: 'hourglass', native: '⏳' },
  { text: 'alarm_clock', native: '⏰' },
  { text: 'watch', native: '⌚' },
  { text: 'unlock', native: '🔓' },
  { text: 'lock', native: '🔒' },
  { text: 'lock_with_ink_pen', native: '🔏' },
  { text: 'closed_lock_with_key', native: '🔐' },
  { text: 'key', native: '🔑' },
  { text: 'mag_right', native: '🔎' },
  { text: 'bulb', native: '💡' },
  { text: 'flashlight', native: '🔦' },
  { text: 'high_brightness', native: '🔆' },
  { text: 'low_brightness', native: '🔅' },
  { text: 'electric_plug', native: '🔌' },
  { text: 'battery', native: '🔋' },
  { text: 'mag', native: '🔍' },
  { text: 'bathtub', native: '🛁' },
  { text: 'bath', native: '🛀' },
  { text: 'shower', native: '🚿' },
  { text: 'toilet', native: '🚽' },
  { text: 'wrench', native: '🔧' },
  { text: 'nut_and_bolt', native: '🔩' },
  { text: 'hammer', native: '🔨' },
  { text: 'door', native: '🚪' },
  { text: 'smoking', native: '🚬' },
  { text: 'bomb', native: '💣' },
  { text: 'gun', native: '🔫' },
  { text: 'hocho', native: '🔪' },
  { text: 'pill', native: '💊' },
  { text: 'syringe', native: '💉' },
  { text: 'moneybag', native: '💰' },
  { text: 'yen', native: '💴' },
  { text: 'dollar', native: '💵' },
  { text: 'pound', native: '💷' },
  { text: 'euro', native: '💶' },
  { text: 'credit_card', native: '💳' },
  { text: 'money_with_wings', native: '💸' },
  { text: 'calling', native: '📲' },
  { text: 'e-mail', native: '📧' },
  { text: 'inbox_tray', native: '📥' },
  { text: 'outbox_tray', native: '📤' },
  { text: 'envelope', native: '✉' },
  { text: 'email', native: '📩' },
  { text: 'incoming_envelope', native: '📨' },
  { text: 'postal_horn', native: '📯' },
  { text: 'mailbox', native: '📫' },
  { text: 'mailbox_closed', native: '📪' },
  { text: 'mailbox_with_mail', native: '📬' },
  { text: 'mailbox_with_no_mail', native: '📭' },
  { text: 'postbox', native: '📮' },
  { text: 'memo', native: '📦' },
  { text: 'page_facing_up', native: '📄' },
  { text: 'page_with_curl', native: '📃' },
  { text: 'scroll', native: '📜' },
  { text: 'bookmark_tabs', native: '📑' },
  { text: 'bar_chart', native: '📊' },
  { text: 'chart_with_upwards_trend', native: '📈' },
  { text: 'chart_with_downwards_trend', native: '📉' },
  { text: 'clipboard', native: '📋' },
  { text: 'date', native: '📅' },
  { text: 'calendar', native: '📆' },
  { text: 'card_index', native: '📇' },
  { text: 'file_folder', native: '📁' },
  { text: 'open_file_folder', native: '📂' },
  { text: 'scissors', native: '✂' },
  { text: 'pushpin', native: '📌' },
  { text: 'paperclip', native: '📎' },
  { text: 'black_nib', native: '✒' },
  { text: 'pencil2', native: '✏' },
  { text: 'straight_ruler', native: '📏' },
  { text: 'triangular_ruler', native: '📐' },
  { text: 'closed_book', native: '📕' },
  { text: 'green_book', native: '📗' },
  { text: 'blue_book', native: '📘' },
  { text: 'orange_book', native: '📙' },
  { text: 'notebook', native: '📓' },
  { text: 'notebook_with_decorative_cover', native: '📔' },
  { text: 'ledger', native: '📒' },
  { text: 'books', native: '📚' },
  { text: 'book', native: '📖' },
  { text: 'bookmark', native: '🔖' },
  { text: 'name_badge', native: '📛' },
  { text: 'microscope', native: '🔬' },
  { text: 'telescope', native: '🔭' },
  { text: 'newspaper', native: '📰' },
  { text: 'art', native: '🎨' },
  { text: 'clapper', native: '🎬' },
  { text: 'microphone', native: '🎤' },
  { text: 'headphones', native: '🎧' },
  { text: 'musical_score', native: '🎼' },
  { text: 'musical_note', native: '🎵' },
  { text: 'notes', native: '🎶' },
  { text: 'musical_keyboard', native: '🎹' },
  { text: 'violin', native: '🎻' },
  { text: 'trumpet', native: '🎺' },
  { text: 'saxophone', native: '🎷' },
  { text: 'guitar', native: '🎸' },
  { text: 'space_invader', native: '[invader]' },
  { text: 'video_game', native: '🎮' },
  { text: 'black_joker', native: '🃏' },
  { text: 'flower_playing_cards', native: '🎴' },
  { text: 'mahjong', native: '🀄' },
  { text: 'game_die', native: '🎲' },
  { text: 'dart', native: '🎯' },
  { text: 'football', native: '🏈' },
  { text: 'basketball', native: '🏀' },
  { text: 'soccer', native: '⚽' },
  { text: 'baseball', native: '⚾' },
  { text: 'tennis', native: '🎾' },
  { text: '8ball', native: '🎱' },
  { text: 'rugby_football', native: '🏉' },
  { text: 'bowling', native: '🎳' },
  { text: 'golf', native: '🏌' },
  { text: 'mountain_bicyclist', native: '🚵' },
  { text: 'bicyclist', native: '🚴' },
  { text: 'checkered_flag', native: '🏁' },
  { text: 'horse_racing', native: '🏇' },
  { text: 'trophy', native: '🏆' },
  { text: 'ski', native: '🎿' },
  { text: 'snowboarder', native: '🏂' },
  { text: 'swimmer', native: '🏊' },
  { text: 'surfer', native: '🏄' },
  { text: 'fishing_pole_and_fish', native: '🎣' },
  { text: 'coffee', native: '☕' },
  { text: 'tea', native: '🍵' },
  { text: 'sake', native: '🍶' },
  { text: 'baby_bottle', native: '🍼' },
  { text: 'beer', native: '🍺' },
  { text: 'beers', native: '🍻' },
  { text: 'cocktail', native: '🍸' },
  { text: 'tropical_drink', native: '🍹' },
  { text: 'wine_glass', native: '🍷' },
  { text: 'fork_and_knife', native: '🍴' },
  { text: 'pizza', native: '🍕' },
  { text: 'hamburger', native: '🍔' },
  { text: 'fries', native: '🍟' },
  { text: 'poultry_leg', native: '🍗' },
  { text: 'meat_on_bone', native: '🍖' },
  { text: 'spaghetti', native: '🍝' },
  { text: 'curry', native: '🍛' },
  { text: 'fried_shrimp', native: '🍤' },
  { text: 'bento', native: '🍱' },
  { text: 'sushi', native: '🍣' },
  { text: 'fish_cake', native: '🍥' },
  { text: 'rice_ball', native: '🍙' },
  { text: 'rice_cracker', native: '🍘' },
  { text: 'rice', native: '🍚' },
  { text: 'ramen', native: '🍜' },
  { text: 'stew', native: '🍲' },
  { text: 'oden', native: '🍢' },
  { text: 'dango', native: '🍡' },
  { text: 'egg', native: '🍳' },
  { text: 'bread', native: '🍞' },
  { text: 'doughnut', native: '🍩' },
  { text: 'custard', native: '🍮' },
  { text: 'icecream', native: '🍦' },
  { text: 'ice_cream', native: '🍨' },
  { text: 'shaved_ice', native: '🍧' },
  { text: 'birthday', native: '🎂' },
  { text: 'cake', native: '🍰' },
  { text: 'cookie', native: '🍪' },
  { text: 'chocolate_bar', native: '🍫' },
  { text: 'candy', native: '🍬' },
  { text: 'lollipop', native: '🍭' },
  { text: 'honey_pot', native: '🍯' },
  { text: 'apple', native: '🍎' },
  { text: 'green_apple', native: '🍏' },
  { text: 'tangerine', native: '🍊' },
  { text: 'lemon', native: '🍋' },
  { text: 'cherries', native: '🍒' },
  { text: 'grapes', native: '🍇' },
  { text: 'watermelon', native: '🍉' },
  { text: 'strawberry', native: '🍓' },
  { text: 'peach', native: '🍑' },
  { text: 'melon', native: '🍈' },
  { text: 'banana', native: '🍌' },
  { text: 'pear', native: '🍐' },
  { text: 'pineapple', native: '🍍' },
  { text: 'sweet_potato', native: '🍠' },
  { text: 'eggplant', native: '🍆' },
  { text: 'tomato', native: '🍅' },
  { text: 'corn', native: '🌽' },
  { text: 'house', native: '🏠' },
  { text: 'house_with_garden', native: '🏡' },
  { text: 'school', native: '🏫' },
  { text: 'office', native: '🏢' },
  { text: 'post_office', native: '🏣' },
  { text: 'hospital', native: '🏥' },
  { text: 'bank', native: '🏦' },
  { text: 'convenience_store', native: '🏪' },
  { text: 'hotel', native: '🏨' },
  { text: 'love_hotel', native: '🏩' },
  { text: 'wedding', native: '💒' },
  { text: 'church', native: '⛪' },
  { text: 'department_store', native: '🏬' },
  { text: 'european_post_office', native: '🏤' },
  { text: 'city_sunrise', native: '🌅' },
  { text: 'city_sunset', native: '🌇' },
  { text: 'japanese_castle', native: '🏯' },
  { text: 'european_castle', native: '🏰' },
  { text: 'tent', native: '⛺' },
  { text: 'factory', native: '🏭' },
  { text: 'tokyo_tower', native: '🗼' },
  { text: 'japan', native: '🗾' },
  { text: 'mount_fuji', native: '🗻' },
  { text: 'sunrise_over_mountains', native: '🌄' },
  { text: 'sunrise', native: '🌅' },
  { text: 'stars', native: '🌃' },
  { text: 'statue_of_liberty', native: '🗽' },
  { text: 'bridge_at_night', native: '🌉' },
  { text: 'carousel_horse', native: '🎠' },
  { text: 'ferris_wheel', native: '🎡' },
  { text: 'fountain', native: '⛲' },
  { text: 'roller_coaster', native: '🎢' },
  { text: 'ship', native: '🚢' },
  { text: 'sailboat', native: '⛵' },
  { text: 'speedboat', native: '🚤' },
  { text: 'rowboat', native: '🚣' },
  { text: 'anchor', native: '⚓' },
  { text: 'rocket', native: '🚀' },
  { text: 'airplane', native: '✈' },
  { text: 'seat', native: '💺' },
  { text: 'helicopter', native: '🚁' },
  { text: 'steam_locomotive', native: '🚂' },
  { text: 'tram', native: '🚊' },
  { text: 'station', native: '🚉' },
  { text: 'mountain_railway', native: '🚞' },
  { text: 'train2', native: '🚆' },
  { text: 'bullettrain_side', native: '🚄' },
  { text: 'bullettrain_front', native: '🚅' },
  { text: 'light_rail', native: '🚈' },
  { text: 'metro', native: '🚇' },
  { text: 'monorail', native: '🚝' },
  { text: 'train', native: '🚃' },
  { text: 'trolleybus', native: '🚎' },
  { text: 'bus', native: '🚌' },
  { text: 'oncoming_bus', native: '🚍' },
  { text: 'blue_car', native: '🚙' },
  { text: 'oncoming_automobile', native: '🚘' },
  { text: 'red_car', native: '🚗' },
  { text: 'taxi', native: '🚕' },
  { text: 'oncoming_taxi', native: '🚖' },
  { text: 'articulated_lorry', native: '🚛' },
  { text: 'truck', native: '🚚' },
  { text: 'rotating_light', native: '🚨' },
  { text: 'police_car', native: '🚓' },
  { text: 'oncoming_police_car', native: '🚔' },
  { text: 'fire_engine', native: '🚒' },
  { text: 'ambulance', native: '🚑' },
  { text: 'minibus', native: '🚐' },
  { text: 'bike', native: '🚲' },
  { text: 'aerial_tramway', native: '🚡' },
  { text: 'suspension_railway', native: '🚟' },
  { text: 'mountain_cableway', native: '🚠' },
  { text: 'tractor', native: '🚜' },
  { text: 'barber', native: '💈' },
  { text: 'busstop', native: '🚏' },
  { text: 'ticket', native: '🎫' },
  { text: 'vertical_traffic_light', native: '🚦' },
  { text: 'traffic_light', native: '🚥' },
  { text: 'warning', native: '⚠' },
  { text: 'construction', native: '🚧' },
  { text: 'beginner', native: '🔰' },
  { text: 'fuelpump', native: '⛽' },
  { text: 'izakaya_lantern', native: '🏮' },
  { text: 'slot_machine', native: '🎰' },
  { text: 'hotsprings', native: '♨' },
  { text: 'moyai', native: '🗿' },
  { text: 'circus_tent', native: '🎪' },
  { text: 'performing_arts', native: '🎭' },
  { text: 'round_pushpin', native: '📍' },
  { text: 'triangular_flag_on_post', native: '🚩' },
  { text: 'jp', native: '🇯🇵' },
  { text: 'kr', native: '🇰🇷' },
  { text: 'de', native: '🇩🇪' },
  { text: 'cn', native: '🇨🇳' },
  { text: 'us', native: '🇺🇸' },
  { text: 'fr', native: '🇫🇷' },
  { text: 'es', native: '🇪🇸' },
  { text: 'it', native: '🇮🇹' },
  { text: 'ru', native: '🇷🇺' },
  { text: 'dog', native: '🐶' },
  { text: 'wolf', native: '🐺' },
  { text: 'cat', native: '🐱' },
  { text: 'mouse', native: '🐭' },
  { text: 'hamster', native: '🐹' },
  { text: 'rabbit', native: '🐰' },
  { text: 'frog', native: '🐸' },
  { text: 'tiger', native: '🐯' },
  { text: 'koala', native: '🐨' },
  { text: 'bear', native: '🐻' },
  { text: 'pig', native: '🐷' },
  { text: 'pig_nose', native: '🐽' },
  { text: 'cow', native: '🐮' },
  { text: 'boar', native: '🐗' },
  { text: 'monkey_face', native: '🐵' },
  { text: 'monkey', native: '🐒' },
  { text: 'horse', native: '🐴' },
  { text: 'sheep', native: '🐑' },
  { text: 'elephant', native: '🐘' },
  { text: 'panda_face', native: '🐼' },
  { text: 'penguin', native: '🐧' },
  { text: 'bird', native: '🐦' },
  { text: 'baby_chick', native: '🐤' },
  { text: 'hatched_chick', native: '🐥' },
  { text: 'hatching_chick', native: '🐣' },
  { text: 'chicken', native: '🐔' },
  { text: 'snake', native: '🐍' },
  { text: 'turtle', native: '🐢' },
  { text: 'bug', native: '🐛' },
  { text: 'honeybee', native: '🐝' },
  { text: 'ant', native: '🐜' },
  { text: 'beetle', native: '🐞' },
  { text: 'snail', native: '🐌' },
  { text: 'octopus', native: '🐙' },
  { text: 'shell', native: '🐚' },
  { text: 'tropical_fish', native: '🐠' },
  { text: 'fish', native: '🐟' },
  { text: 'dolphin', native: '🐬' },
  { text: 'whale', native: '🐳' },
  { text: 'whale2', native: '🐋' },
  { text: 'cow2', native: '🐄' },
  { text: 'ram', native: '🐏' },
  { text: 'rat', native: '🐀' },
  { text: 'water_buffalo', native: '🐃' },
  { text: 'tiger2', native: '🐅' },
  { text: 'rabbit2', native: '🐇' },
  { text: 'dragon', native: '🐉' },
  { text: 'racehorse', native: '🏇' },
  { text: 'rooster', native: '🐓' },
  { text: 'dog2', native: '🐕' },
  { text: 'pig2', native: '🐖' },
  { text: 'mouse2', native: '🐁' },
  { text: 'ox', native: '🐂' },
  { text: 'dragon_face', native: '🐲' },
  { text: 'blowfish', native: '🐡' },
  { text: 'crocodile', native: '🐊' },
  { text: 'goat', native: '🐐' },
  { text: 'camel', native: '🐪' },
  { text: 'dromedary_camel', native: '🐪' },
  { text: 'leopard', native: '🐆' },
  { text: 'cat2', native: '🐈' },
  { text: 'poodle', native: '🐩' },
  { text: 'paw_prints', native: '🐾' },
  { text: 'bouquet', native: '💐' },
  { text: 'cherry_blossom', native: '🌸' },
  { text: 'tulip', native: '🌷' },
  { text: 'four_leaf_clover', native: '🍀' },
  { text: 'rose', native: '🌹' },
  { text: 'sunflower', native: '🌻' },
  { text: 'hibiscus', native: '🌺' },
  { text: 'maple_leaf', native: '🍁' },
  { text: 'leaves', native: '🍃' },
  { text: 'fallen_leaf', native: '🍂' },
  { text: 'herb', native: '🌿' },
  { text: 'ear_of_rice', native: '🌾' },
  { text: 'mushroom', native: '🍄' },
  { text: 'cactus', native: '🌵' },
  { text: 'palm_tree', native: '🌴' },
  { text: 'evergreen_tree', native: '🌲' },
  { text: 'deciduous_tree', native: '🌳' },
  { text: 'chestnut', native: '🌰' },
  { text: 'seedling', native: '🌱' },
  { text: 'blossom', native: '🌼' },
  { text: 'globe_with_meridians', native: '🌐' },
  { text: 'sun_with_face', native: '🌞' },
  { text: 'full_moon_with_face', native: '🌝' },
  { text: 'new_moon_with_face', native: '🌚' },
  { text: 'new_moon', native: '🌑' },
  { text: 'waxing_crescent_moon', native: '🌒' },
  { text: 'first_quarter_moon', native: '🌓' },
  { text: 'waxing_gibbous_moon', native: '🌔' },
  { text: 'full_moon', native: '🌕' },
  { text: 'waning_gibbous_moon', native: '🌖' },
  { text: 'last_quarter_moon', native: '🌗' },
  { text: 'waning_crescent_moon', native: '🌘' },
  { text: 'last_quarter_moon_with_face', native: '🌜' },
  { text: 'first_quarter_moon_with_face', native: '🌛' },
  { text: 'moon', native: '🌙' },
  { text: 'earth_africa', native: '🌍' },
  { text: 'earth_americas', native: '🌎' },
  { text: 'earth_asia', native: '🌏' },
  { text: 'volcano', native: '🌋' },
  { text: 'milky_way', native: '🌌' },
  { text: 'sunny', native: '☀' },
  { text: 'partly_sunny', native: '⛅' },
  { text: 'cloud', native: '☁' },
  { text: 'zap', native: '⚡' },
  { text: 'rainbow', native: '🌈' },
  { text: 'foggy', native: '🌁' },
  { text: 'cyclone', native: '🌀' },
  { text: 'umbrella', native: '☔' },
  { text: 'snowman', native: '⛄' },
  { text: 'snowflake', native: '❄' },
  { text: 'ocean', native: '🌊' },
  { text: '1234', native: '🔢' },
  { text: 'hash', native: '#️⃣' },
  { text: 'symbols', native: '🔣' },
  { text: 'keycap_ten', native: '🔟' },
  { text: 'arrow_up', native: '⬆' },
  { text: 'arrow_down', native: '⬇' },
  { text: 'arrow_left', native: '⬅' },
  { text: 'arrow_right', native: '➡' },
  { text: 'capital_abcd', native: '🔠' },
  { text: 'abcd', native: '🔡' },
  { text: 'abc', native: '🔤' },
  { text: 'arrow_upper_right', native: '↗' },
  { text: 'arrow_upper_left', native: '↖' },
  { text: 'arrow_lower_right', native: '↘' },
  { text: 'arrow_lower_left', native: '↙' },
  { text: 'left_right_arrow', native: '↔' },
  { text: 'arrow_up_down', native: '↕' },
  { text: 'arrows_counterclockwise', native: '🔄' },
  { text: 'arrow_backward', native: '◀' },
  { text: 'arrow_forward', native: '▶' },
  { text: 'arrow_up_small', native: '🔼' },
  { text: 'arrow_down_small', native: '🔽' },
  { text: 'leftwards_arrow_with_hook', native: '↩' },
  { text: 'arrow_right_hook', native: '↪' },
  { text: 'information_source', native: 'ℹ' },
  { text: 'rewind', native: '⏪' },
  { text: 'fast_forward', native: '⏩' },
  { text: 'arrow_double_up', native: '⏩' },
  { text: 'arrow_double_down', native: '⏬' },
  { text: 'arrow_heading_down', native: '⤵' },
  { text: 'arrow_heading_up', native: '⤴' },
  { text: 'ok', native: '🆗' },
  { text: 'twisted_rightwards_arrows', native: '🔀' },
  { text: 'repeat', native: '🔁' },
  { text: 'repeat_one', native: '🔂' },
  { text: 'new', native: '🆕' },
  { text: 'up', native: '🆙' },
  { text: 'cool', native: '🆒' },
  { text: 'free', native: '🆓' },
  { text: 'ng', native: '🆖' },
  { text: 'signal_strength', native: '📶' },
  { text: 'cinema', native: '🎦' },
  { text: 'koko', native: '🈁' },
  { text: 'u6307', native: '🈯' },
  { text: 'u7a7a', native: '🈳' },
  { text: 'u6e80', native: '🈵' },
  { text: 'u5408', native: '🈴' },
  { text: 'u7981', native: '🈲' },
  { text: 'ideograph_advantage', native: '🉐' },
  { text: 'u5272', native: '🈹' },
  { text: 'u55b6', native: '🈺' },
  { text: 'u6709', native: '🈶' },
  { text: 'u7121', native: '🈚' },
  { text: 'restroom', native: '🚻' },
  { text: 'mens', native: '🚹' },
  { text: 'womens', native: '🚺' },
  { text: 'baby_symbol', native: '🚼' },
  { text: 'wc', native: '🚾' },
  { text: 'potable_water', native: '🚰' },
  { text: 'put_litter_in_its_place', native: '🚮' },
  { text: 'parking', native: '🅿' },
  { text: 'wheelchair', native: '♿' },
  { text: 'no_smoking', native: '🚭' },
  { text: 'u6708', native: '🈷' },
  { text: 'u7533', native: '🈸' },
  { text: 'sa', native: '🈂' },
  { text: 'm', native: 'Ⓜ' },
  { text: 'passport_control', native: '🛂' },
  { text: 'baggage_claim', native: '🛄' },
  { text: 'left_luggage', native: '🛅' },
  { text: 'customs', native: '🛃' },
  { text: 'accept', native: '🉑' },
  { text: 'secret', native: '㊙' },
  { text: 'congratulations', native: '㊗' },
  { text: 'cl', native: '🆑' },
  { text: 'sos', native: '🆘' },
  { text: 'id', native: '🆔' },
  { text: 'no_entry_sign', native: '🚫' },
  { text: 'underage', native: '🔞' },
  { text: 'no_mobile_phones', native: '📵' },
  { text: 'do_not_litter', native: '🚯' },
  { text: 'non-potable_water', native: '🚱' },
  { text: 'no_bicycles', native: '🚳' },
  { text: 'no_pedestrians', native: '🚷' },
  { text: 'children_crossing', native: '🚸' },
  { text: 'no_entry', native: '⛔' },
  { text: 'eight_spoked_asterisk', native: '✳' },
  { text: 'negative_squared_cross_mark', native: '❎' },
  { text: 'white_check_mark', native: '✅' },
  { text: 'eight_pointed_black_star', native: '✴' },
  { text: 'heart_decoration', native: '💟' },
  { text: 'vs', native: '🆚' },
  { text: 'vibration_mode', native: '📳' },
  { text: 'mobile_phone_off', native: '📴' },
  { text: 'a', native: '🅰' },
  { text: 'b', native: '🅱' },
  { text: 'ab', native: '🆎' },
  { text: 'o2', native: '🅾' },
  { text: 'diamond_shape_with_a_dot_inside', native: '💠' },
  { text: 'loop', native: '➿' },
  { text: 'recycle', native: '♻' },
  { text: 'aries', native: '♈' },
  { text: 'taurus', native: '♉' },
  { text: 'gemini', native: '♊' },
  { text: 'cancer', native: '♋' },
  { text: 'leo', native: '♌' },
  { text: 'virgo', native: '♍' },
  { text: 'libra', native: '♎' },
  { text: 'scorpius', native: '♏' },
  { text: 'sagittarius', native: '♐' },
  { text: 'capricorn', native: '♑' },
  { text: 'aquarius', native: '♒' },
  { text: 'pisces', native: '♓' },
  { text: 'ophiuchus', native: '⛎' },
  { text: 'six_pointed_star', native: '✡' },
  { text: 'atm', native: '🏧' },
  { text: 'chart', native: '💹' },
  { text: 'heavy_dollar_sign', native: '💲' },
  { text: 'currency_exchange', native: '💱' },
  { text: 'copyright', native: '©' },
  { text: 'registered', native: '®' },
  { text: 'tm', native: '™' },
  { text: 'x', native: '❌' },
  { text: 'bangbang', native: '‼' },
  { text: 'interrobang', native: '⁉' },
  { text: 'heavy_exclamation_mark', native: '❗' },
  { text: 'grey_exclamation', native: '❕' },
  { text: 'question', native: '❔' },
  { text: 'o', native: '⭕' },
  { text: 'top', native: '🔝' },
  { text: 'end', native: '🔚' },
  { text: 'back', native: '🔙' },
  { text: 'on', native: '🔛' },
  { text: 'soon', native: '🔜' },
  { text: 'arrows_clockwise', native: '🔃' },
  { text: 'clock12', native: '🕛' },
  { text: 'clock1230', native: '🕧' },
  { text: 'clock1', native: '🕐' },
  { text: 'clock130', native: '🕜' },
  { text: 'clock2', native: '🕑' },
  { text: 'clock230', native: '🕝' },
  { text: 'clock3', native: '🕒' },
  { text: 'clock330', native: '🕞' },
  { text: 'clock4', native: '🕓' },
  { text: 'clock430', native: '🕟' },
  { text: 'clock5', native: '🕔' },
  { text: 'clock530', native: '🕠' },
  { text: 'clock6', native: '🕕' },
  { text: 'clock7', native: '🕖' },
  { text: 'clock8', native: '🕗' },
  { text: 'clock9', native: '🕘' },
  { text: 'clock10', native: '🕙' },
  { text: 'clock11', native: '🕚' },
  { text: 'clock630', native: '🕡' },
  { text: 'clock730', native: '🕢' },
  { text: 'clock830', native: '🕣' },
  { text: 'clock930', native: '🕤' },
  { text: 'clock1030', native: '🕥' },
  { text: 'clock1130', native: '🕦' },
  { text: 'heavy_multiplication_x', native: '✖' },
  { text: 'heavy_plus_sign', native: '➕' },
  { text: 'heavy_minus_sign', native: '➖' },
  { text: 'heavy_division_sign', native: '➗' },
  { text: 'spades', native: '♠' },
  { text: 'hearts', native: '♥' },
  { text: 'clubs', native: '♣' },
  { text: 'diamonds', native: '♦' },
  { text: 'white_flower', native: '💮' },
  { text: '100', native: '💯' },
  { text: 'heavy_check_mark', native: '✔' },
  { text: 'ballot_box_with_check', native: '☑' },
  { text: 'radio_button', native: '🔘' },
  { text: 'link', native: '🔗' },
  { text: 'curly_loop', native: '➰' },
  { text: 'wavy_dash', native: '〰' },
  { text: 'part_alternation_mark', native: '〽' },
  { text: 'trident', native: '🔱' },
  { text: 'black_square', native: '⬛' },
  { text: 'small_red_triangle', native: '🔺' },
  { text: 'black_square_button', native: '🔲' },
  { text: 'white_square_button', native: '🔳' },
  { text: 'black_circle', native: '⚫' },
  { text: 'white_circle', native: '⚪' },
  { text: 'red_circle', native: '🔴' },
  { text: 'large_blue_circle', native: '🔵' },
  { text: 'small_red_triangle_down', native: '🔻' },
  { text: 'white_square', native: '⬜' },
  { text: 'large_orange_diamond', native: '🔶' },
  { text: 'large_blue_diamond', native: '🔷' },
  { text: 'small_orange_diamond', native: '🔸' },
  { text: 'small_blue_diamond', native: '🔹' },
  { text: 'handshake', native: '🤝' },
  { text: 'baoquan', native: '[抱拳]' },
  { text: 'gouyin', native: '[勾引]' },
  { text: 'penguin_trembling', native: '[企鹅发抖]' },
  { text: 'penguin_circle_around', native: '[企鹅转圈]' }
];

export default emojiMore;
